import {
  ParagraphArticleHighlights,
  ParagraphArticlesFiltered,
  ParagraphCTA,
  ParagraphDownloads,
  ParagraphEventsUpcoming,
  ParagraphFAQ,
  ParagraphMap,
  ParagraphPartnersHighlights,
  ParagraphPartnersOverview,
  ParagraphThemesOverview,
  ParagraphPersonsFiltered,
  ParagraphProjectsFiltered,
  ParagraphQuote,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphUSP,
  ParagraphUSPSubparagraph,
  ParagraphVacanciesFiltered,
  ParagraphVacanciesMap,
  ParagraphWebform,
  ParagraphDocumentsFiltered,
  ParagraphThemesSelected,
  ParagraphDocumentsHighlighted,
  ParagraphPersonsSelected,
  ParagraphInformation,
} from '../implementations';

const mappers = {
  article_highlights: ParagraphArticleHighlights,
  articles_filtered: ParagraphArticlesFiltered,
  cta_wrapper: ParagraphCTA,
  cta: ParagraphCTA,
  downloads: ParagraphDownloads,
  documents_filtered: ParagraphDocumentsFiltered,
  documents_highlighted: ParagraphDocumentsHighlighted,
  faq: ParagraphFAQ,
  map: ParagraphMap,
  partners_highlighted: ParagraphPartnersHighlights,
  partners_overview: ParagraphPartnersOverview,
  persons_filtered: ParagraphPersonsFiltered,
  persons_selected: ParagraphPersonsSelected,
  projects_filtered: ParagraphProjectsFiltered,
  quote: ParagraphQuote,
  text_image_grid: ParagraphTextImageGrid,
  text_media: ParagraphTextMedia,
  text: ParagraphText,
  themes_overview: ParagraphThemesOverview,
  themes_selected: ParagraphThemesSelected,
  upcoming_events: ParagraphEventsUpcoming,
  usp_subparagraph: ParagraphUSPSubparagraph,
  usp: ParagraphUSP,
  webform_wrapper: ParagraphWebform,
  vacancies_filtered: ParagraphVacanciesFiltered,
  vacancies_map: ParagraphVacanciesMap,
  information: ParagraphInformation,
};

export default mappers;
